import { useState, useCallback } from 'react';
import myDriveService, { QuotaInfo } from '../services/myDriveService';
import { useMessage } from '../../../../contexts/MessageContext';

export function useQuota() {
  const { showApiError } = useMessage();
  const [quota, setQuota] = useState<QuotaInfo | null>(null);

  const reload = useCallback(async () => {
    try {
      const data = await myDriveService.getQuota();
      setQuota(data);
    } catch (err) {
      showApiError(err);
    }
  }, [showApiError]);

  return { quota, reload };
}
